export enum RouteColor {
  transfer = '#FFC700',
  airport = '#0051FF',
  transit = '#0051FF',
}
